import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useEffectOnce } from 'react-use';
import { useReporting } from './Reporting';

function PageTrackerComponent() {
  const location = useLocation();
  const { track } = useReporting();

  useEffectOnce(() => {
    track('app::initialized');
  });

  useEffect(() => {
    track('app::page-change');
  }, [location, track]);

  return null;
}

export default function PageTracker() {
  return <PageTrackerComponent />;
}
